import gql from 'graphql-tag';

export const EMPLOYEE_RESILIENCE_ANCHORS = gql`
  query reportingEmployeesResilienceAnchors($employeeId: ID!) {
    reportingEmployeesResilienceAnchors(employeeId: $employeeId)
  }
`;
